import { render, staticRenderFns } from "./InformationEventsAdd.vue?vue&type=template&id=66981d39&scoped=true"
import script from "./InformationEventsAdd.vue?vue&type=script&lang=js"
export * from "./InformationEventsAdd.vue?vue&type=script&lang=js"
import style0 from "./InformationEventsAdd.vue?vue&type=style&index=0&id=66981d39&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66981d39",
  null
  
)

export default component.exports